import { toast } from 'react-toastify'
import React from 'react'


function createLayout(title, message) {
    return (
        <div>
            <b>{title}</b>
            <p>{message}</p>
        </div>
    )
}

export default {
    notifyError: message => {
        return toast.error(createLayout(message.title, message.message))
    },
    notifyInfo: message => {
        return toast.info(createLayout(message.title, message.message))
    },
    notifySuccess: message => {
        return toast.success(createLayout(message.title, message.message))
    },
    notifyWarning: message => {
        return toast.warning(createLayout(message.title, message.message))
    }
}
